export default "__VITE_ASSET__efa5ca9b__"